import React from "react";
import { Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";
import { buildBreadcrumbItems } from "./breadcrumb-items";

/**
 * Global breadcrumb derived from the current route. Ancestors are real
 * anchors (react-router Link → middle-click friendly); the current page is
 * plain text (antd convention). Renders nothing on the dashboard and on
 * unknown routes. Colors come from antd tokens, so both themes just work.
 */
const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const items = buildBreadcrumbItems(location.pathname, location.search);

  if (items.length === 0) return null;

  return (
    <Breadcrumb
      style={{ marginBottom: 12 }}
      items={items.map((item) => ({
        title: item.href ? (
          <Link to={item.href}>{item.label}</Link>
        ) : (
          item.label
        ),
      }))}
    />
  );
};

export default Breadcrumbs;
